import ctsDefaultTheme from './ctsDefaultTheme';

export { ctsDefaultTheme };

export default ctsDefaultTheme;
